export default "__VITE_ASSET__CTxIU9Cv__"